import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 92 92",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 92 92\" id=\"icon-play\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M89 46c0 23.748-19.252 43-43 43S3 69.748 3 46 22.252 3 46 3s43 19.252 43 43Zm3 0c0 25.405-20.595 46-46 46S0 71.405 0 46 20.595 0 46 0s46 20.595 46 46ZM34 68.517l37.5-21.651a1 1 0 0 0 0-1.732L34 23.484a1 1 0 0 0-1.5.865v43.302a1 1 0 0 0 1.5.866Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol